export const CREATE_USER = "CREATE_USER";
export const UPDATE_USER = "UPDATE_USER";
export const DELETE_USER = "DELETE_USER";
export const SELECT_USER = "SELECT_USER";
export const SELECT_USER_ROLES = "SELECT_USER_ROLES";
export const FETCH_USERS = "FETCH_USERS";
